import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MomMeetingComponent } from './mom-meeting.component';
import { MomRecordMeetingComponent } from '../mom-record-meeting/mom-record-meeting.component';

const routes: Routes = [
  { 
    path: '', component: MomMeetingComponent,  data: { breadcrumb: 'Meeting' },
  },
  { path: ':mode', component: MomMeetingComponent,  data: { breadcrumb: 'Create Meeting' } },
  { path: 'view/:mode', component: MomMeetingComponent,  data: { breadcrumb: 'View Meeting' } },
  { path: 'archieve-meeting/:mode', component: MomMeetingComponent,  data: { breadcrumb: 'Archieve Meeting' } },
  { path: 'meeting-logs/:mode', component: MomMeetingComponent,  data: { breadcrumb: 'Meeting Logs' } },
  { path: 'start-meeting/:mode', component: MomRecordMeetingComponent,  data: { breadcrumb: 'Record Meeting' } },
  { path: 'edit-meeting/:mode', component: MomRecordMeetingComponent,  data: { breadcrumb: 'Edit Meeting' } },
  { path: 'meeting-approval/:mode', component: MomRecordMeetingComponent,  data: { breadcrumb: 'Meeting Approval' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MomMeetingRoutingModule { }
